/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import TSAbstractEntity from './TSAbstractEntity';
import TSBatchJobInformation from './TSBatchJobInformation';
import TSReportTypeParams from './TSReportTypeParams';
import {TSSerializable} from './TSSerializable';

/**
 * DTO fuer einen WorkJob
 */
export default class TSWorkJob extends TSAbstractEntity implements TSSerializable<TSWorkJob> {

    private _workJobType: string;
    private _startinguser: string;
    private _batchJobStatus: string;
    private _params: TSReportTypeParams;
    private _requestURI: string;
    private _resultData: string;
    private _executionId: string;
    private _execution: TSBatchJobInformation;
    private _serfDokumentId: string;

    public get workJobType(): string {
        return this._workJobType;
    }

    public set workJobType(value: string) {
        this._workJobType = value;
    }

    public get startinguser(): string {
        return this._startinguser;
    }

    public set startinguser(value: string) {
        this._startinguser = value;
    }

    public get batchJobStatus(): string {
        return this._batchJobStatus;
    }

    public set batchJobStatus(value: string) {
        this._batchJobStatus = value;
    }

    public get params(): TSReportTypeParams {
        return this._params;
    }

    public set params(value: TSReportTypeParams) {
        this._params = value;
    }

    public get executionId(): string {
        return this._executionId;
    }

    public set executionId(value: string) {
        this._executionId = value;
    }

    public get requestURI(): string {
        return this._requestURI;
    }

    public set requestURI(value: string) {
        this._requestURI = value;
    }

    public get resultData(): string {
        return this._resultData;
    }

    public set resultData(value: string) {
        this._resultData = value;
    }

    public get execution(): TSBatchJobInformation {
        return this._execution;
    }

    public set execution(value: TSBatchJobInformation) {
        this._execution = value;
    }

    public get serfDokumentId(): string {
        return this._serfDokumentId;
    }

    public set serfDokumentId(value: string) {
        this._serfDokumentId = value;
    }

    deserialize(restObject: any): TSWorkJob {
        super.deserialize(restObject);

        this.startinguser = restObject.startinguser;
        this.batchJobStatus = restObject.batchJobStatus;
        this.executionId = restObject.executionId;
        this.params = JSON.parse(restObject.params);
        this.workJobType = restObject.workJobType;
        this.resultData = restObject.resultData;
        this.requestURI = restObject.requestURI;
        this.serfDokumentId = restObject.serfDokumentId;
        this.execution = this.deserializeOrCreate(restObject.execution, new TSBatchJobInformation());

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.params = this.params;
        return restObject;
    }

    public static deserializeArray(data: any): Array<TSWorkJob> {
        let workJobArray: Array<TSWorkJob> = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                workJobArray[i] = new TSWorkJob().deserialize(data[i]);
            }
        } else {
            workJobArray[0] = new TSWorkJob().deserialize(data);
        }
        return workJobArray;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/TSWorkJob.ts